import React, { useEffect, useState } from "react";
import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, Snackbar, TextField, Typography } from "@mui/material";
import NewEmailCandidateDialog from "./NewEmailCandidateDialog";
import { CONTACT_COMMUNICATION_EVENT, communicationRequest, contactCallHref } from "../../utils/contactCommunication";
import { toolbarPillButtonSx } from "../../utils/pillButtonStyles";

export default function ContactCommunicationDialogs() {
  const [target, setTarget] = useState(null);
  const [phone, setPhone] = useState("");
  const [notice, setNotice] = useState("");
  useEffect(() => {
    const open = (event) => {
      setTarget(event.detail);
      setPhone(event.detail?.message?.candidate_phone || "");
    };
    window.addEventListener(CONTACT_COMMUNICATION_EVENT, open);
    return () => window.removeEventListener(CONTACT_COMMUNICATION_EVENT, open);
  }, []);
  const submit = async (form, action) => {
    const data = new FormData();
    Object.entries({ ...target.message, action, to_email: form.to, cc_email: form.cc, bcc_email: form.bcc, subject: form.subject, body_text: form.body })
      .forEach(([key, value]) => data.append(key, value || ""));
    (form.attachments || []).forEach((attachment) => { if (attachment.file) data.append("attachments", attachment.file); });
    await communicationRequest("gmail/compose", data);
    setTarget(null);
    setNotice(action === "draft" ? "Draft saved to Gmail." : "Email sent.");
  };
  const href = contactCallHref(phone);
  return <>
    {target?.kind === "email" && <NewEmailCandidateDialog open onClose={() => setTarget(null)} message={target.message}
      onSaveDraft={(form) => submit(form, "draft")} onSend={(form) => submit(form, "send")} />}
    <Dialog open={target?.kind === "call"} onClose={() => setTarget(null)} fullWidth maxWidth="xs">
      <DialogTitle data-popup-header>Call {target?.message?.candidate_name || "Contact"}</DialogTitle>
      <DialogContent>
        {!target?.message?.candidate_phone && <Alert severity="info" sx={{ mb: 2 }}>No phone number is saved for this contact. Enter a number to call.</Alert>}
        <TextField autoFocus fullWidth label="Phone number" value={phone} onChange={(event) => setPhone(event.target.value)} sx={{ mt: 1 }} />
        <Typography sx={{ mt: 2 }} color="text.secondary">Call opens your device’s calling app.</Typography>
      </DialogContent>
      <DialogActions data-popup-footer><Button onClick={() => setTarget(null)}>Cancel</Button><Button component="a" href={href || undefined} disabled={!href} className="pill" sx={toolbarPillButtonSx}>Call</Button></DialogActions>
    </Dialog>
    <Snackbar open={Boolean(notice)} autoHideDuration={5000} onClose={() => setNotice("")} message={notice} />
  </>;
}
